import { FunctionComponent, ChangeEvent } from 'react';
import classnames from 'classnames';
import * as Yup from 'yup';

// Contexts
import { useViewDetected } from '@Components/Utils/ViewDetected';

// Utilities
import { useFormik } from 'formik';
import { phoneRegExp, useSupportAirTable } from '@Libs/utils';

// Components
import Image from '@Components/Utils/Image';
import InputGroup from '@Components/UI/InputGroup';

// Styles
import styles from './FromGetInfo.module.scss';

// Icons
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface FromGetInfoProps {
    className?: string;
}

const validationSchema = Yup.object({
    phoneNumber: Yup.string().matches(phoneRegExp, 'Số điện thoại chưa đúng').required('Vui lòng nhập số điện thoại'),
});

const FromGetInfo: FunctionComponent<FromGetInfoProps> = (props) => {
    const { deviceType } = useViewDetected();
    const { loading, sendSupport } = useSupportAirTable();

    const { values, errors, resetForm, setFieldValue, handleSubmit } = useFormik({
        validationSchema,
        initialValues: {
            fullName: '',
            phoneNumber: '',
        },
        onSubmit: () =>
            sendSupport(values.phoneNumber, values.fullName, (error) => {
                if (!error) {
                    resetForm();

                    gtag('event', 'send_support_form', {
                        event_category: 'Support',
                        event_label: 'Người dùng vẫn chưa tìm thấy thông tin mình cần',
                    });
                }
            }),
    });

    const handleChangeValue = (event: ChangeEvent<HTMLInputElement>, field: string) => {
        setFieldValue(field, event.target.value);
    };

    const className = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
        props.className,
    ]);

    const btnClassName = classnames([
        styles.btn_send,
        {
            [styles.btn_loading]: loading,
        },
    ]);

    return (
        <form className={className} onSubmit={handleSubmit}>
            <h3 className={styles.form_title}>Bạn vẫn chưa tìm thấy thông tin mình cần?</h3>
            <span className={styles.hint}>Hãy để lại số điện thoại, chúng tôi sẽ tư vấn nhanh nhất cho bạn.</span>
            <InputGroup
                id={'faq_name'}
                inputProps={{
                    value: values.fullName,
                    placeholder: 'Nhập tên',
                    onChange: (event) => handleChangeValue(event, 'fullName'),
                }}
                className={styles.input_group}
            />
            <InputGroup
                id={'faq_phone_number'}
                className={styles.input_group}
                inputProps={{
                    value: values.phoneNumber,
                    placeholder: 'Nhập số điện thoại',
                    onChange: (event) => handleChangeValue(event, 'phoneNumber'),
                }}
                placeholderClassName={styles.placeholder}
            />
            {errors.phoneNumber && (
                <label className={styles.phone_group_error}>
                    <FontAwesomeIcon className={styles.icon} icon={faTimesCircle} />
                    {errors.phoneNumber}
                </label>
            )}
            <button className={btnClassName} type="submit">
                {loading ? <Image width="25px" height="25px" src={'/assets/loading.png'} /> : 'Gửi ngay'}
            </button>
        </form>
    );
};

export default FromGetInfo;
